import { translate } from '@/i18n/index'
/** dateKey is already a club calendar date; never shift it through the device timezone. */
export function formatFacilityBookingDate(dateKey, locale = 'en-GB') {
  if (!dateKey) return ''
  const date = new Date(`${dateKey}T12:00:00.000Z`)
  if (!Number.isFinite(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' }).format(date)
}
export function formatFacilityMinutes(value, locale = 'en-GB') {
  const minutes = Number.parseInt(value, 10)
  return Number.isFinite(minutes) && minutes > 0
    ? new Intl.NumberFormat(locale, { style: 'unit', unit: 'minute', unitDisplay: 'long' }).format(minutes)
    : null
}

const BOOKING_STATUS_KEYS = Object.freeze({
  // event_registrations.status is independent of payment and attendance.
  "registered": "facilityBooking.confirmed",
  "rejected": "reciprocalClubs.status.rejected",
  "void": "portalPresentation.member_cancelled",
  "confirmed": "facilityBooking.confirmed",
  "booked": "golf.canonical.attendance.booked",
  "reserved": "portalPresentation.member_reserved",
  "pending": "portalPresentation.member_pending",
  "pending_payment": "portalPresentation.member_payment_required",
  "pending_confirmation": "portalPresentation.member_pending_confirmation",
  "charged_to_account": "portalPresentation.member_charged_to_account",
  "paid": "portalPresentation.member_paid",
  "waitlisted": "portalPresentation.member_waitlisted",
  "cancelled": "portalPresentation.member_cancelled",
  "canceled": "portalPresentation.member_cancelled",
  "completed": "portalPresentation.member_completed",
  "checked_in": "golf.bookingModal.checkedIn",
  "no_show": "portalPresentation.member_no_show",
  "refunded": "portalPresentation.member_refunded",
  "failed": "portalPresentation.member_failed",
  "expired": "portalPresentation.member_expired",
  "held": "portalPresentation.member_held",
  "upcoming": "portalPresentation.member_upcoming_caption"
})
export function formatFacilityBookingStatus(value, t = translate) {
  return t(BOOKING_STATUS_KEYS[String(value || '').trim().toLowerCase()] || "portalPresentation.member_status_unavailable")
}
